var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dialog-preview" }, [
    _vm.showEmptyContent
      ? _c("div", { staticClass: "preview-enpty" }, [_vm._v("暂无内容")])
      : _c("div", { staticClass: "preview-main" }, [
          _c(
            "div",
            { staticClass: "preview-main_left" },
            [
              _c("rice-preview-form", {
                ref: "previewForm",
                attrs: {
                  formData: _vm._formDatas,
                  startNonius: true,
                  toggleClearModel: _vm.toggleClearModel
                },
                on: {
                  firstElement: function($event) {
                    _vm.firstElement = arguments[0]
                  },
                  getUpdateData: _vm.onFormChange
                },
                model: {
                  value: _vm.formModels,
                  callback: function($$v) {
                    _vm.formModels = $$v
                  },
                  expression: "formModels"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "preview-main_line" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "preview-main_right" },
            [
              _c("rice-preview-render", {
                attrs: {
                  formData: _vm._formDatas,
                  scrollPosition: _vm.firstElement
                },
                model: {
                  value: _vm.formModels,
                  callback: function($$v) {
                    _vm.formModels = $$v
                  },
                  expression: "formModels"
                }
              })
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-037c33bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037c33bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/RicePreviewBridge/src/RicePreviewBridge.vue
// module id = null
// module chunks = 